import * as React from 'react'
import { TaskActionListConnected } from './TaskActionListConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore, MOCK_TEAM_A_ID } from 'mockState'

export const TaskActionListExamples = () => {
  return (
    <div className="TaskActionListExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TaskActionListConnected taskId={MOCK_TEAM_A_ID} />
      </Provider>
    </div>
  )
}
